/** Packages — edit view (delegates to the shared PackageForm). */
import { PackageForm } from "./_PackageForm";

export function PackageEdit() {
  return <PackageForm action="edit" />;
}

export default PackageEdit;
